import { Autocomplete, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import setToast from "../../helpers/toaster.helper";
import { BackMobileIcon, CancelIcon } from "../../icon";
import { ChannelUserModel } from "../../models/users.model";
import ButtonComponent from "../shared/button/button.component";
import { ToasterTexts, buttonLabels } from "../shared/constants";
import { validateForm } from "../shared/form-validation";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ChannelUserService } from "../../services/ChannelUserService";
import { LoadAllChannelUsers, LoadChannelUsers } from "../../actions";
import { useParams } from "react-router";
import { ChannelOrganizationModel } from "../../models/channels/channels.model";
import * as selector from '../../selectors/selectors';

interface Props {
    isSysAdmin?: boolean;
    show: boolean;
    onClose?: () => void;
    User?: ChannelUserModel;
    Organizations?: ChannelOrganizationModel[];
}


const ChannelInviteUser = (props: Props) => {
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const params = useParams();
    const dispatch = useDispatch()
    const [roles, setRoles] = useState([{ Name: "Admin", Value: 1, Show: false }, { Name: "Organization Admin", Value: 2, Show: (CurrentUser?.RoleID === 1 || CurrentUser?.RoleID === 2) }, { Name: "Agent", Value: 3, Show: true }, { Name: "Manager", Value: 4, Show: CurrentUser?.RoleID !== 4 }])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isEdit, setIsEdit] = useState<boolean>(!!props?.User && !!props?.User?.ID)
    const [userData, setuserData] = useState<any>(
        props.User || {
            ID: "",
            Email: "",
            FirstName: "",
            LastName: "",
            FullName: "",
            OrganizationID: "",
            OrganizationName: "",
            Password: "",
            RoleID: -1,
            UserStatus: 0,
            IsProfileUpdated: false,
            IsWidgetAdded: false,
            ImageReferenceId: "",
            SignUpMethod: 0,
            AddedBy: "",
            CreatedDateTime: "",
            UpdatedDateTime: "",
            NotificationEnabled: false
        }
    )

    const [errors, setErrors] = useState<{
        FirstName: string,
        LastName: string,
        Email: string,
        Role: string,
        Organization: string;
    }>({
        FirstName: "",
        LastName: "",
        Email: "",
        Role: "",
        Organization: ""
    })

    const formSubmit = (event: any) => {
        event.preventDefault();
        if (validateForm({
            FirstName: userData.FirstName,
            LastName: userData.LastName,
            Email: userData.Email,
            Role: userData.RoleID,
        },
            (Errors) => setErrors({ ...errors, ...Errors }))) {
            setIsLoading(true)
            const obj = {
                "user_id": isEdit ? userData.ID : "",
                "fName": userData.FirstName,
                "lName": userData.LastName,
                "email": userData.Email.trim(),
                "role": userData.RoleID,
                "admin_id": ChannelUserService.getCurrentUserFromLocalStorage()?.ID,
                "organization_id": ChannelUserService.getCurrentUserFromLocalStorage()?.OrganizationID
            }
            let Name = userData.FirstName + " " + userData.LastName
            if (!!userData.ID) {
                ChannelUserService.updateUserInvitation(obj)
                    .then(() => {
                        props.onClose()
                        setIsLoading(false)
                        props.isSysAdmin ? LoadAllChannelUsers(dispatch) : LoadChannelUsers(dispatch);
                        setToast(ToasterTexts.USER_EDIT_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                    })
                    .catch((err) => {
                        setToast(err.response.data.message, ToasterType.DANGER)
                        setIsLoading(false)
                    });
            } else {
                ChannelUserService.sendInvitation(obj)
                    .then(() => {
                        setIsLoading(false)
                        setToast(ToasterTexts.USER_ADD_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                        props.onClose();
                        props.isSysAdmin ? LoadAllChannelUsers(dispatch) : LoadChannelUsers(dispatch);
                    })
                    .catch((err) => {
                        setToast(err.response.data.message, ToasterType.DANGER)
                        setIsLoading(false)
                    });
            }
        }
    }

    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value },
            (Errors) => {
                setErrors({ ...errors, ...Errors })
            })
        setuserData({ ...userData, [name]: value });
    };


    return (
        <div className="w-fill">
            {IsMobileDevice ?
                <div className="paper-background o-x-hidden w-fill h-v-100">
                    <Grid item xs={12}>
                        <div className='box-shadow-display-background-shadow d-flex p-2'>
                            {IsMobileDevice && <span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => props.onClose()} /></span>}
                            <span className={`h1 my-auto color-add-details-title mr-auto`}>{isEdit ? "Edit User" : "Add User"}</span>
                        </div>
                    </Grid>

                    <form
                        noValidate
                        autoComplete="no"
                        className="p-2"
                    >
                        <Grid container direction="row" spacing={3} className="pt-2">
                            <Grid item xs={12} >
                                <TextField
                                    name="FirstName"
                                    placeholder="First Name"
                                    label="First Name"
                                    variant="outlined"
                                    size="small"
                                    required
                                    fullWidth
                                    value={userData.FirstName}
                                    onChange={(e) => handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.FirstName}
                                </FormHelperText>
                            </Grid>
                            <Grid item xs={12} >
                                <TextField
                                    placeholder="Last Name"
                                    name="LastName"
                                    label="Last Name"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    required
                                    value={userData.LastName}
                                    onChange={(e) =>
                                        handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.LastName}
                                </FormHelperText>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className="mt-3">
                            <TextField
                                fullWidth
                                label="Email"
                                name="Email"
                                placeholder="Email"
                                size="small"
                                required
                                variant="outlined"
                                value={userData.Email}
                                disabled={isEdit}
                                onChange={(e) =>
                                    handleChange(e.target.name, e.target.value)
                                }
                                InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                autoComplete='no'

                            />
                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                {errors.Email}
                            </FormHelperText>
                        </Grid>
                        {props.isSysAdmin &&
                            <Grid item xs={12} className="mt-3">
                                <Autocomplete
                                    size="small"
                                    classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    options={props.Organizations}
                                    disabled={isEdit}
                                    getOptionLabel={(option) => option?.Name}
                                    onChange={(event: any, value: any | null) => {
                                        if (value) {
                                            setuserData({ ...userData, OrganizationID: value.ID, OrganizationName: value.Name, RoleID: value.Name === "SYSTEM ADMIN" ? -1 : userData.RoleID });
                                            setErrors({ ...errors, Organization: "" })
                                        }
                                        else {
                                            setuserData({ ...userData, OrganizationID: "", OrganizationName: "" });
                                            setErrors({ ...errors, Organization: "Organization cannot be blank" })
                                        }
                                    }}
                                    value={props.Organizations?.find(x => x.ID === userData.OrganizationID)}
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops} >
                                            {
                                                <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                    {option?.Name}
                                                </div>
                                            }
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Organization" name="roleId" required variant="outlined" />}
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.Organization}
                                </FormHelperText>
                            </Grid>
                        }
                        <Grid item xs={12} className="mt-3">
                            <Autocomplete
                                size="small"
                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                disabled={isEdit && ((CurrentUser.RoleID === 4 && userData?.RoleID === 4) || (CurrentUser.RoleID === 2 && userData?.RoleID === 2))}
                                options={roles.filter(x => x.Show)}
                                getOptionLabel={(option) => option?.Name}
                                onChange={(event: any, value: any | null) => {
                                    if (value) {
                                        setuserData({ ...userData, RoleID: value.Value });
                                        setErrors({ ...errors, Role: "" })
                                    }
                                    else {
                                        setuserData({ ...userData, RoleID: -1 });
                                        setErrors({ ...errors, Role: "Role cannot be blank" })
                                    }
                                }}
                                value={roles.find(x => x.Value === userData.RoleID)}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} >
                                        {
                                            <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                {option?.Name}
                                            </div>
                                        }
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label="Role" name="roleId" required variant="outlined" />}
                            />
                            <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                {errors.Role}
                            </FormHelperText>
                        </Grid>
                        <div className="d-flex flex-direction mt-6">
                            <ButtonComponent OnClick={formSubmit} Loading={isLoading} ButtonLabel={buttonLabels.SAVE} ClassName={""} Variant={"primary-btn-small"} />
                            <ButtonComponent OnClick={() => { props?.onClose() }} ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} ClassName="mt-2" />
                        </div>
                    </form>
                </div>
                :
                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={true}
                    onClose={() => props.onClose()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: "w-66 br-2 dialogue-shadow" }}

                    disableEscapeKeyDown
                >
                    <DialogTitle id="alert-dialog-title" className="dialog-header">
                        <div className='d-flex'>
                            <span className={"h2-regular color-display-title"}>{isEdit ? "Edit User" : "Add User"}</span>
                            <Tooltip title='Close' placement='bottom-start'>
                                <CancelIcon className={"c-pointer ml-auto"} onClick={() => props.onClose()} />
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className="o-x-hidden">
                        <form
                            noValidate
                            autoComplete="no"
                        >
                            <Grid container direction="row" spacing={2} className="pt-1">
                                <Grid item xs={6} >
                                    <TextField autoFocus
                                        name="FirstName"
                                        placeholder="First Name"
                                        label="First Name"
                                        variant="outlined"
                                        size="small"
                                        required
                                        fullWidth
                                        value={userData.FirstName}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.FirstName}
                                    </FormHelperText>
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        placeholder="Last Name"
                                        name="LastName"
                                        label="Last Name"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        required
                                        value={userData.LastName}
                                        onChange={(e) =>
                                            handleChange(e.target.name, e.target.value)
                                        }
                                        InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                        autoComplete='no'
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.LastName}
                                    </FormHelperText>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className="mt-3">
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="Email"
                                    placeholder="Email"
                                    size="small"
                                    required
                                    variant="outlined"
                                    value={userData.Email}
                                    disabled={isEdit}
                                    onChange={(e) =>
                                        handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'

                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.Email}
                                </FormHelperText>
                            </Grid>
                            {props.isSysAdmin &&
                                <Grid item xs={12} className="mt-3">
                                    <Autocomplete
                                        size="small"
                                        classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                        options={props.Organizations}
                                        disabled={isEdit}
                                        getOptionLabel={(option) => option?.Name}
                                        onChange={(event: any, value: any | null) => {
                                            if (value) {
                                                setuserData({ ...userData, OrganizationID: value.ID, OrganizationName: value.Name, RoleID: value.Name === "SYSTEM ADMIN" ? -1 : userData.RoleID });
                                                setErrors({ ...errors, Organization: "" })
                                            }
                                            else {
                                                setuserData({ ...userData, OrganizationID: "", OrganizationName: "" });
                                                setErrors({ ...errors, Organization: "Organization cannot be blank" })
                                            }
                                        }}
                                        value={props.Organizations?.find(x => x.ID === userData.OrganizationID)}
                                        renderOption={(defaultprops, option: any) => (
                                            <li {...defaultprops} >
                                                {
                                                    <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                        {option?.Name}
                                                    </div>
                                                }
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label="Organization" name="roleId" required variant="outlined" />}
                                    />
                                    <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                        {errors.Organization}
                                    </FormHelperText>
                                </Grid>
                            }
                            <Grid item xs={12} className="mt-3">
                                <Autocomplete
                                    size="small"
                                    classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                    disabled={isEdit && ((CurrentUser.RoleID === 4 && userData?.RoleID === 4) || (CurrentUser.RoleID === 2 && userData?.RoleID === 2))}
                                    options={roles.filter(x => x.Show)}
                                    getOptionLabel={(option) => option?.Name}
                                    onChange={(event: any, value: any | null) => {
                                        if (value) {
                                            setuserData({ ...userData, RoleID: value.Value });
                                            setErrors({ ...errors, Role: "" })
                                        }
                                        else {
                                            setuserData({ ...userData, RoleID: -1 });
                                            setErrors({ ...errors, Role: "Role cannot be blank" })
                                        }
                                    }}
                                    value={roles.find(x => x.Value === userData.RoleID)}
                                    renderOption={(defaultprops, option: any) => (
                                        <li {...defaultprops} >
                                            {
                                                <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                    {option?.Name}
                                                </div>
                                            }
                                        </li>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Role" name="roleId" required variant="outlined" />}
                                />
                                <FormHelperText className="h6-regular color-primary-danger t-align-right">
                                    {errors.Role}
                                </FormHelperText>
                            </Grid>
                            <div className="d-flex float-right mt-3">
                                <ButtonComponent OnClick={formSubmit} Loading={isLoading} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 mr-1"} Variant={"primary-btn-small"} />
                                <ButtonComponent OnClick={() => { props?.onClose() }} ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} />
                            </div>
                        </form>
                    </DialogContent>
                </Dialog>
            }
        </div>
    )
}

export default ChannelInviteUser;